import * as React from "react"
import "./maintenance.scss"
import rhrLogo from "../assets/images/RHR-Logo.svg"

const MaintenancePage = () => {
    return (
        <div className="maintenance-page">
            <div className="container">
                <div className="logo">
                    <img
                        src={rhrLogo}
                        alt="RHR LOGO"
                        className="maintenance-logo img-responsive"
                    />
                </div>
                <h1>We're Under Maintenance</h1>
                <p>Our website is currently undergoing scheduled maintenance.<br />
                    We should be back shortly. Thank you for your patience.</p>

                <div className="contact">
                    <p>Need help? Contact us:</p>
                    <p><a href="mailto:reservations@gohotels.ph">reservations@gohotels.ph</a></p>
                    <p><a href="mailto:reservations@summithotels.ph">reservations@summithotels.ph</a></p>
                    <p><a href="tel:+639988887788">+63 998 888 7788</a></p>
                    <p><a href="tel:+639989972080">+63 998 997 2080 </a></p>
                    <p><a href="tel:+63283970111">+63 (2) 8 397 0111</a></p>
                </div>

                <div className="footer-maintenance">
                    &copy; 2025 Robinsons Hotels & Resorts
                </div>
            </div>
        </div>
    )
}

export default MaintenancePage
